import { FilterAltOutlined } from '@mui/icons-material'
import { Box, Divider, IconButton, List, Skeleton } from '@mui/material'
import { SearchField } from '@/components/SearchField'
import { SecondaryInformationListItem } from './SecondaryInformationListItem'
import { TrackingListItem } from './TrackingListItem'
import { TrackingsProjectFilterChip } from './TrackingsProjectFilterChip'
import { TrackingsTimespanFilterChip } from './TrackingsTimespanFilterChip'

const divider = (
    <Divider>
        <Skeleton width={100} />
    </Divider>
)

const startedEndedAt = (
    <Skeleton style={{ display: 'inline-block' }} width={50} />
)

const duration = <Skeleton width={200} />

export const TrackingsListPendingComponent: React.FC<{
    searchText?: string
    from?: Date
    to?: Date
    projectIds?: string[]
}> = ({ searchText, from, to, projectIds }) => (
    <>
        <SearchField value={searchText} disabled={true} fullWidth={true} />

        <Box sx={{ marginTop: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            <IconButton disabled={true} size={'small'}>
                <FilterAltOutlined />
            </IconButton>

            {(!!from || !!to) && (
                <TrackingsTimespanFilterChip from={from} to={to} />
            )}

            {projectIds?.map(pId => (
                <TrackingsProjectFilterChip
                    key={pId}
                    projectName={<Skeleton width={100} />}
                />
            ))}
        </Box>

        <List sx={{ '& li': { marginTop: 1, marginBottom: 1 } }}>
            {divider}

            <TrackingListItem
                startedAt={startedEndedAt}
                endedAt={startedEndedAt}
                duration={duration}
                projectName={<Skeleton width={250} />}
                publicDescription={<Skeleton height={50} />}
            />

            <SecondaryInformationListItem primary={duration} />

            <TrackingListItem
                startedAt={startedEndedAt}
                endedAt={startedEndedAt}
                duration={duration}
                projectName={<Skeleton width={250} />}
                publicDescription={<Skeleton height={50} />}
                internalDescription={<Skeleton height={75} />}
            />

            <SecondaryInformationListItem primary={duration} />

            {divider}

            <TrackingListItem
                startedAt={startedEndedAt}
                endedAt={startedEndedAt}
                duration={duration}
                projectName={<Skeleton width={250} />}
                publicDescription={<Skeleton height={50} />}
            />

            <TrackingListItem
                startedAt={startedEndedAt}
                endedAt={startedEndedAt}
                duration={duration}
                projectName={<Skeleton width={250} />}
                publicDescription={<Skeleton height={50} />}
            />

            <TrackingListItem
                startedAt={startedEndedAt}
                endedAt={startedEndedAt}
                duration={duration}
                projectName={<Skeleton width={250} />}
                publicDescription={<Skeleton />}
            />

            <SecondaryInformationListItem primary={duration} />
        </List>

        <Box sx={{ display: 'flex', gap: 0.6 }}>
            <Skeleton variant={'circular'} height={32} width={32} />
            <Skeleton variant={'circular'} height={32} width={32} />
            <Skeleton variant={'circular'} height={32} width={32} />
            <Skeleton variant={'circular'} height={32} width={32} />
        </Box>
    </>
)
